import React from 'react';
import { Container } from 'react-bootstrap';
import { withAuthorization } from '../Session';
import List from './List'
class InstaBanners extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Container>
                <List {...this.props}></List>
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(InstaBanners);
